/**
 * Configuration Stripe pour SimulReno
 */

export const STRIPE_CONFIG = {
  // Prix des produits Stripe
  PRICES: {
    CREDIT_UNIT: 'price_1S650vHgJ40en0UjWkJFTwPj', // Crédit unitaire 19,90€
    SUBSCRIPTION_MONTHLY: 'price_1S64aZHgJ40en0UjRGuDI9xC', // Abonnement mensuel 29,90€
    SUBSCRIPTION_ANNUAL: 'price_1T9NirHgJ40en0UjrlzpgwhG', // Abonnement annuel 319,90€
  },

  // URLs de redirection
  URLS: {
    SUCCESS: `${window.location.origin}/credits/confirmation`,
    CANCEL: `${window.location.origin}/credits/purchase`,
  },

  // Configuration des produits
  PRODUCTS: {
    CREDIT: {
      id: 'credit_unit',
      name: 'Crédit SimulReno',
      description: 'Estimation détaillée pour une adresse',
      price: 19.90,
      currency: 'EUR',
      type: 'one_time'
    },
    SUBSCRIPTION_MONTHLY: {
      id: 'subscription_monthly',
      name: 'Abonnement SimulReno - Mensuel',
      description: 'Estimations illimitées',
      price: 29.90,
      currency: 'EUR',
      type: 'recurring',
      interval: 'month'
    },
    SUBSCRIPTION_ANNUAL: {
      id: 'subscription_annual',
      name: 'Abonnement SimulReno - Annuel',
      description: 'Estimations illimitées - Économisez 11%',
      price: 319.90,
      pricePerMonth: 26.66,
      currency: 'EUR',
      type: 'recurring',
      interval: 'year',
      savingsPercent: 11
    }
  }
} as const;

export type StripeProductType = keyof typeof STRIPE_CONFIG.PRODUCTS;
export type BillingInterval = 'monthly' | 'annual';